module.exports = __webpack_public_path__ + "img/whatsapp.ea3b75a5.png";